module.exports = __webpack_public_path__ + "static/robot-6c993105c8c1ffdae8de4ea1b949c7dc.svg";